export * from './partner-master-api.interface';
